<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row class="text-center">      

      <v-carousel>
        <v-carousel-item
          v-for="(item, i) in wallpapers"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
          cycle
          continuous
          ripple
        ></v-carousel-item>
      </v-carousel>
      <v-card
        class="mx-auto"
        flat
        width="800"
      >
        <v-card-text>
          <v-row
            align="center"
            justify="center"           
            
          >           
              <h2 class="primary--text font-weight-light font-italic">
                  Select the link to get started
              </h2>
           
              
           
          </v-row>
          <v-row
            align="center"
            justify="center"
            class="mt-6"
          >
            <v-btn
                color="primary"
                dark
                large
                class="mr-4  mb-4"
                href="https://eldorado-east-student-registration.ttschoolnet.org"
              >
              Student Registration
              </v-btn>

              <v-btn
                color="primary"
                dark
                large
                outlined
                class="mr-4 mb-4"
                href="https://eldoradoeast-studentportal.ttschoolnet.org"                    
              >
                Student Term Reports
              </v-btn>
          </v-row>
        </v-card-text>
        <v-card-actions>
          
        </v-card-actions>
      </v-card>

    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',

    data: () => ({
      wallpapers: [
        {src: require('../assets/wallpapers/wallpaper-1.jpg')},
        {src: require('../assets/wallpapers/wallpaper-2.jpg')},
        {src: require('../assets/wallpapers/wallpaper-3.jpg')},
        // {src: require('../assets/wallpapers/wallpaper-4.jpg')},
      ]
    }),
  }
</script>
